import React from 'react'
import ScheduleBase from 'frontend/schedule/schedule-base'
import PropTypes from 'prop-types'
import moment from 'lib/moment-timezone-custom'
import PlayersCountButtons from 'frontend/schedule/players-count-buttons'
import PlayersCountInput from 'frontend/schedule/players-count-input'
import MinPriceIndicator from 'frontend/schedule/min-price-indicator'
import RoomWeekSelect from 'frontend/schedule/room-week-select'
import ScheduleWeek from 'frontend/schedule/schedule-week'
import PrebookingCodeAuthorization from 'frontend/schedule/prebooking-code-authorization'
import params from 'lib/params'
import Current from 'frontend/lib/current'

export default class RoomSchedule extends ScheduleBase {
  constructor (props) {
    super(props)

    let selectedDate = params.has('selectedDate') ? moment(params.get('selectedDate')) : moment()
    selectedDate = selectedDate > props.openedFrom ? selectedDate : props.openedFrom

    this.state = Object.assign(this.state, { selectedDate, daysLimit: props.daysLimit || 7 })

    // slot of the booking link: ?time=HH:MM&players=N; strict, so 7:00 PM does not become 07:00
    if (params.has('time')) {
      const selectedTime = moment(
        `${selectedDate.format('YYYY-MM-DD')} ${params.get('time')}`,
        'YYYY-MM-DD HH:mm', true,
      )
      if (selectedTime.isValid()) this.state.selectedTime = selectedTime
    }
    const selectedPlayersCount = parseInt(params.get('players'))
    if (!isNaN(selectedPlayersCount)) this.state.selectedPlayersCount = selectedPlayersCount
  }

  updateSchedule ({ selectedDate = null, daysLimit = null } = {}) {
    selectedDate = moment(selectedDate || this.state.selectedDate)
    daysLimit = daysLimit || this.state.daysLimit || 7
    this.fetchSchedule({
      url: '/' + Current.cityId + '/escape-rooms/' + this.props.roomId + '/schedule.json',
      data: {
        room_ids: [this.props.roomId],
        date_from: selectedDate.format('YYYY-MM-DD'),
        date_to: selectedDate.add(daysLimit - 1, 'days').format('YYYY-MM-DD'),
      },
      success: (room) => {
        this.constructor.processRoom(room)
        if (!this.state.selectedPlayersCount && room.presetPlayersCount) {
          this.setState({ selectedPlayersCount: room.presetPlayersCount || room.maxPlayers })
        }
        if (this.state.selectedTime && !this.state.selectedRoom) this.setState({ selectedRoom: room })
        this.setState({ schedule: room })
      },
    })
  }

  handlePrebookingCodeAuthorized (args) {
    this.setState({
      prebooking: args.prebooking,
      selectedPlayersCount: args.prebooking.playersCount,
    })
  }

  // TODO: handleDateSelect() do not fetch schedule if date in current week

  renderFilters () {
    return (
      <div className="filters">
        <div className="select_players_count">
          <h4 className="title" aria-level="2">
            <span className="fix_title">1. Select number of players</span>
          </h4>
          <PlayersCountButtons
            playersWithMinPrices={this.state.schedule.minPriceByPlayersCount}
            minPlayers={this.state.schedule.minPlayers}
            maxPlayers={this.state.schedule.maxPlayers}
            selected={this.state.selectedPlayersCount}
            onSelect={this.handlePlayersCountSelect.bind(this)}
          />
          <div className="players_count_input_with_price_indicator">
            <PlayersCountInput
              minPlayers={this.state.schedule.minPlayers}
              maxPlayers={this.state.schedule.maxPlayers}
              value={this.state.selectedPlayersCount}
              onChange={this.handlePlayersCountSelect.bind(this)}
            />
            <MinPriceIndicator
              playersCount={this.state.selectedPlayersCount}
              playersWithMinPrices={this.state.schedule.minPriceByPlayersCount}
            />
          </div>
        </div>
        <div className="select_date">
          <h4 className="title" aria-level="2">
            <span className="fix_title">2. Select date and time</span>
          </h4>
          <RoomWeekSelect
            selected={this.state.selectedDate}
            onChange={this.handleDateSelect.bind(this)}
          />
        </div>
      </div>
    )
  }

  renderViewFullWeekButtonMaybe () {
    if (this.state.daysLimit >= 7) {
      return null
    }
    return (
      <div className="view-full-week">
        <button className="view-full-week__button" onClick={() => { this.handleDaysLimitSelect(7) }}>
          View full week schedule
        </button>
      </div>
    )
  }

  renderSchedule () {
    return (
      <ScheduleWeek
        room={this.state.schedule}
        hidePrice={!!this.state.prebooking}
        schedule={this.state.schedule}
        selectedDate={this.state.selectedDate}
        selectedTime={this.state.selectedTime}
        selectedRoom={this.state.selectedRoom}
        selectedPlayersCount={this.state.selectedPlayersCount}
        cartItems={this.state.cartItems}
        onSlotSelect={this.handleSlotSelect.bind(this)}
        onGameRemove={this.handleGameRemove.bind(this)}
        onPlayersCountSelect={this.handlePlayersCountSelect.bind(this)}
      />
    )
  }

  render () {
    // if room is opened for booking for customers that have prebooking code only
    if (this.props.prebookingCodeOnly && !this.state.prebooking) {
      return (
        <PrebookingCodeAuthorization
          authorizationUrl={`${window.location.href}/prebooking_code_authorization`}
          onSuccess={this.handlePrebookingCodeAuthorized.bind(this)}
        />
      )
    } else {
      return super.render()
    }
  }
}

RoomSchedule.propTypes = {
  roomId: PropTypes.number.isRequired,
  openedFrom: PropTypes.object,
  presetPlayersCount: PropTypes.number,
  daysLimit: PropTypes.number,
}
